package com.essntl.features.request.ui.addeditrequest

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

sealed interface AddEditRequestNavigation {
    data object AddClient : AddEditRequestNavigation
    data class EditClient(val client: ClientModel) : AddEditRequestNavigation
    data object AddTravelAgent : AddEditRequestNavigation
    data class EditTravelAgent(val travelAgent: TravelAgentModel) : AddEditRequestNavigation
}